import React from 'react';
import { getLabel } from 'utils/getLabel';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { siteFooter as SiteFooter } from 'ui/views/widgets/siteFooter';
 *
 * // render
 * <SiteFooter propName='propValue'/>
 */
export const siteFooter = ( props )  => {
	return (
		<div className='ui-site-footer'>
			<div className='ui-site-footer__content'>
				{ getLabel( props.component.structure.copyrightTitle ) }
			</div>
		</div>
	);
};

// set display name
siteFooter.displayName = 'siteFooter';

// set default props
siteFooter.defaultProps = {
	copyrightTitle: {}
};

/***************************************/

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { siteFooterPreloader as SiteFooterPreloader } from 'ui/views/widgets/siteFooter';
 *
 * // render
 * <SiteFooterPreloader propName='propValue'/>
 */
export const siteFooterPreloader = () => {
	return (
		<div className='ui-site-footer-preloader'>
			<div className='ui-site-footer-preloader__value'></div>
		</div>
	);
};

// set display name
siteFooterPreloader.displayName = 'siteFooterPreloader';

// set default props
siteFooterPreloader.defaultProps = {};
